document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const newImg = new Image();
          newImg.onload = () => {
            img.src = newImg.src;
            img.removeAttribute('data-src'); // 如果只需要加载一次
            img.removeAttribute('srcset');
            observer.unobserve(img); // 停止观察该元素
          };
          newImg.src = img.getAttribute('data-src');
        }
      });
    },
    {
      rootMargin: '50px' // 预加载距离视口 50px 的图片
    }
  );

  class YGImage extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg();
    }

    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img);
      });
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage);
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => {});
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML =
        $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (
        e.target.className == 'yg-popup-box-close' ||
        e.target.className == 'yg-popup-box'
      ) {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate =
        this.querySelector('template') ||
        this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => {});
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  class YGSwiper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.getAllAttributes();
      this.initSwiper();
    }

    getAllAttributes() {
      let booleanAttrs = [
        'loop',
        'pagination',
        'navigation',
        'scrollbar',
        'centeredslidesbounds',
        'centeredslides'
      ];
      let numberAttrs = [
        'initialslide',
        'slidesoffsetbefore',
        'slidesoiffsetafter'
      ];
      let jsonAttrs = ['breakpoints'];
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (numberAttrs.includes(cleanName)) {
            value = Number(value);
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      console.log('pairs', pairs);
      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      console.log('result', result);
      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        centeredSlides: this['centeredslides'] || false,
        centeredSlidesBounds: this['centeredslidesbounds'] || false,
        initialSlide: this['initialslide'] || 0,
        slidesoffsetbefore: this['slidesoffsetbefore'] || 0,
        slidesoiffsetafter: this['slidesoiffsetafter'] || 0,
        loop: this['loop'],
        autoplay: this['autoplay']
          ? {
              delay: this['autoplay'],
              stopOnLastSlide: false,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        pagination: this['pagination']
          ? {
              el: '.swiper-pagination',
              clickable: true,
              type: 'bullets'
            }
          : false,
        scrollbar: this['scrollbar']
          ? {
              el: '.swiper-scrollbar'
            }
          : false,
        navigation: this['navigation']
          ? {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        // 添加事件处理
        on: {
          init: (e) => {
            if (e.passedParams.loop && e.slides.length < 4) {
              e.slides.forEach((slide) => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              });
            }
          }
        }
      });
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper);
  }

  class YGImageTabSwiper extends HTMLElement {
    constructor() {
      super();
      this.labelClick = this.labelClick.bind(this);

      this.$labelList = this.querySelectorAll('.yg-image-label');
      this.$contentList = this.querySelectorAll('.yg-image-content');
    }

    connectedCallback() {
      this.$labelList.forEach((label, index) => {
        label.addEventListener('click', () => this.labelClick(index));
      });
    }

    disconnectedCallback() {
      this.$labelList.forEach((label, index) => {
        label.removeEventListener('click', () => this.labelClick(index));
      });
    }

    labelClick(index) {
      // 移除所有活动状态
      this.$labelList.forEach((label) => {
        label.classList.remove('active');
      });
      this.$contentList.forEach((content) => {
        content.classList.remove('active');
      });
      
      this.$labelList[index].classList.add('active');
      this.$contentList[index].classList.add('active');

      // 添加新的活动状态
      const parent = this.$labelList[index].parentElement;
      if (parent && this.isScrollable(parent)) {
        const containerRect = parent.getBoundingClientRect();
        const targetRect = this.$labelList[index].getBoundingClientRect();
        const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 20;

        parent.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }

    isScrollable(el) {
      if (!el) return false;

      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;
    
      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;
    
      return canScrollVertically || canScrollHorizontally;
    }
  }

  if (!window.customElements.get('yg-image-tab-swiper')) {
    window.customElements.define('yg-image-tab-swiper', YGImageTabSwiper);
  }
  class AccordionFaq extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.initializeFaqItems();
        this.addEventListeners();
    }
    initializeFaqItems() {
        this.faqItems = this.querySelectorAll('.faq-container');
        this.descriptions = this.querySelectorAll('.description');
    }
    addEventListeners() {
        this.addEventListener('click', (e) => {
            const faqElement = e.target.closest('.faq-container');
            if (!faqElement) return;
            this.toggleFaq(faqElement);
        });
    }
    toggleFaq(faqElement) {
        const isActive = faqElement.classList.contains('active');
        
        this.closeAllFaqs();
        if (!isActive) {
            const description = faqElement.nextElementSibling;
            if (description && description.classList.contains('description')) {
                faqElement.classList.add('active');
                description.classList.add('active');
            }
        }
    }
    closeAllFaqs() {
          this.faqItems.forEach(faq => faq.classList.remove('active'));
          this.descriptions.forEach(desc => desc.classList.remove('active'));
      }
    }

    if (!window.customElements.get('accordion-faq')) {
      customElements.define('accordion-faq', AccordionFaq);
    }

    class YGSwiperControl extends HTMLElement {
        constructor() {
            super()
        }
        
        connectedCallback() {
          this.init()
        }

        init() {
          let _this = this;

          this.mainSwiper = new Swiper(this.querySelector('.yg-main-swiper'), {
            slidesPerView: 1,
            spaceBetween: 20,
            // loop: true,
            centeredSlides: true,
            // navigation: {
            //   nextEl: this.querySelector('.yg-slide-next'),
            //   prevEl: this.querySelector('.yg-slide-prev'),
            // },
          });

          this.thumbSwiper = new Swiper(this.querySelector('.yg-thumb-swiper'), {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: true,
            centeredSlides: true,
            // slideToClickedSlide: true,
            navigation: {
              nextEl: this.querySelector('.yg-slide-next'),
              prevEl: this.querySelector('.yg-slide-prev'),
            },
            breakpoints: {
              699: {
                slidesPerView: 7,
                spaceBetween: 24,
              },
            },
            on: {
              transitionEnd: function () {
                _this.mainSwiper.slideTo(this.realIndex);
              }
            }
          });

          // this.mainSwiper.controller.control = this.thumbSwiper;
          // this.thumbSwiper.controller.control = this.mainSwiper;
        }
    }
    if (!window.customElements.get('yg-swiper-control')) {
        window.customElements.define('yg-swiper-control', YGSwiperControl)
    }
});
